// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-5a58ad59]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.notes[data-v-5a58ad59] {\n  margin: 15px 0 0 18px;\n  font-size: 13px;\n  color: #606266;\n}\n.notes li[data-v-5a58ad59] {\n  margin-bottom: 4px;\n}\n.row-error-text[data-v-5a58ad59] {\n  color: #f56c6c;\n  font-size: 12px;\n  line-height: 1.3;\n  margin-top: 4px;\n  white-space: normal;\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
